import { render, staticRenderFns } from "./LocationMap.vue?vue&type=template&id=487a06f4&scoped=true&"
import script from "./LocationMap.vue?vue&type=script&lang=js&"
export * from "./LocationMap.vue?vue&type=script&lang=js&"
import style0 from "./LocationMap.vue?vue&type=style&index=0&id=487a06f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a06f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487a06f4')) {
      api.createRecord('487a06f4', component.options)
    } else {
      api.reload('487a06f4', component.options)
    }
    module.hot.accept("./LocationMap.vue?vue&type=template&id=487a06f4&scoped=true&", function () {
      api.rerender('487a06f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Charts/Layouts/components/LocationMap.vue"
export default component.exports